import { StringHelper } from '../../helpers/string-helper';

export class HeightWidthTuple {
  display?: string;

  constructor(public height: number, public width: number) {}

  calculateDisplay(): void {
    this.display = `${StringHelper.join(
      [
        this.height == null ? null : '' + this.height,
        this.width == null ? null : '' + this.width
      ],
      ' x '
    )} cm`;
  }
}
